import React, { useRef, useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './Resume.css';

const Resume = () => {
  const resumeRef = useRef();
  const [markdownContent, setMarkdownContent] = useState('');

  useEffect(() => {
    fetch('/resume.md')
      .then(response => response.text())
      .then(text => setMarkdownContent(text))
      .catch(error => console.error('Error loading resume:', error));
  }, []);

  const downloadPDF = async () => {
    const element = resumeRef.current;
    const canvas = await html2canvas(element, {
      scale: 1.2, // Reduced from 2 to 1.2 for better balance of quality vs file size
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff', // Ensure white background
      removeContainer: true
    });
    
    // Use JPEG format with compression instead of PNG
    const imgData = canvas.toDataURL('image/jpeg', 0.85); // 85% quality for good compression
    const pdf = new jsPDF('p', 'mm', 'a4');
    
    const imgWidth = 210;
    const pageHeight = 295;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    // Use JPEG format in PDF as well
    pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save('Joshua_Wentzell_Resume.pdf');
  };

  return (
    <div className="resume-page">
      <div className="resume-header">
        <div className="container">
          <h1>Resume</h1>
          <button onClick={downloadPDF} className="btn btn-primary download-btn">
            Download PDF
          </button>
        </div>
      </div>
      
      <div className="resume-content" ref={resumeRef}>
        <div className="container">
          {markdownContent ? (
            <div className="markdown-content">
              <ReactMarkdown>
                {markdownContent}
              </ReactMarkdown>
            </div>
          ) : (
            <div>Loading resume...</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Resume;